import API from '@core/services/API'
import { cid, container } from 'inversify-props'
import { Store } from 'vuex'
import { SharedVariable } from './../model/SharedVariable'
import { UIService } from '@core/services/UIService'

export const permissionChecking = (user, to) => {
  // For now, just a strict hardcoded check, but when permission is created
  // using casl ability, we will use that to check instead, for now,
  // Check if user has rights to the route
  const restrictedPages = ['Client Policies List', 'Admin', 'Payee List', 'client-list', 'Admin Product List']
  if (user.systemrole !== 'ops-staff' && restrictedPages.includes(to.name)) {
    throw new Error('Unauthorized access to page')
  }
}

export function routerRedirect (store: Store<any>, publicPage: string[]) {
  const $api = container.get<API>('$api')
  const sharedVariable = container.get<SharedVariable>(cid.SharedVariable)
  const uiService = sharedVariable.uiService ? sharedVariable.uiService : new UIService()

  return async (to, from, next) => {
    // if is public page, no need to login, continue
    if (publicPage.includes(to.name)) {
      return next()
    }

    // If the user is logged in, continue
    if (store.getters.currentUser.isLogin) {
      // Checking for permission
      try {
        await permissionChecking(store.getters.currentUser, to)
      } catch (error) {
        await uiService.alert.show({
          type: 'error',
          message: error
        })
        return next({ path: '/', replace: true })
      }

      return next()
    }

    // If the user is not logged in, redirect to login page and
    // let the login page handle the redirection accordingly
    const { params, hash, query } = to
    /* eslint-disable @typescript-eslint/camelcase */
    query.redirect_uri = to.path // this should be in sync with LoginMixin's redirectHome
    /* eslint-enable */

    $api.account.loginGet()
      .then(response => {
        if (response && response.isLogin) {
          const login = response
          const infoPromise = $api.account.loginInfoGet({
            accountID: login.accountID
          })
            .then(response => { return response })
            .catch(async error => {
              console.error('login.js: Exception', error)
              await uiService.alert.show({
                type: 'error',
                message: error
              })
            })

          const metaPromise = $api.account.loginMetaGet({
            _oid: login.accountID
          })
            .then(response => { return response.meta })
            .catch(async error => {
              console.error('login.js: Exception', error)
              await uiService.alert.show({
                type: 'error',
                message: error
              })
            })

          Promise.all([infoPromise, metaPromise]).then((values: {}[]) => {
            const [info, meta] = values
            store.dispatch('login', { ...login, ...info, ...meta }).then(async () => {
              try {
                await permissionChecking(store.getters.currentUser, to)
              } catch (error) {
                await uiService.alert.show({
                  type: 'error',
                  message: error
                })
                return next({ path: '/', replace: true })
              }
              return next()
            })
          })
        } else {
          return next({ path: '/', params, hash, query, replace: true })
        }
      })
      .catch(async error => {
        console.error('login.js: Exception', error)
        await uiService.alert.show({
          type: 'error',
          message: error
        })
        return next({ path: '/', params, hash, query, replace: true })
      })
  }
}
